// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"ded19b6e","845":"da25e9fd"}[chunkId] + ".chunk.css";
};